import routerOptions0 from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@4.2.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.24_eslint@9.39.1_oxlint@1.26.0_oxl_9e05633248f8aea984820b28623ab0ac/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}